import React, { useState, useEffect, useRef } from "react";
import { Form, FormGroup, Label, Input } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";

import { getAccountType } from "../types";
import { CircularProgress } from "../../../..";
import { AccountMode, showToast } from "../../../../utils/Helper";

const Questions = ({
  questions: accQuestions,
  accountId,
  isReadOnly,
  setAccountData,
  account,
  services,
  mode,
  riskByPersonIsEnabled,
}) => {
  const [questions, setQuestions] = useState(undefined);
  const [loadingSave, setLoadingSave] = useState(false);

  const valueref = useRef();
  const accountref = useRef();

  useEffect(() => {
    if (mode !== AccountMode.New) {
      if (!accQuestions) {
        const body = {
          AccountGetInfo: {
            GetAccountDataOnboardingId: account.AccountOnboardingId,
            GetAccountDataId: accountId,
            GetAccountDataType: getAccountType.Questions,
          },
        };
        if (mode === AccountMode.New) {
          services.fetchNewAccountInfo(body, (data) => {
            if (data && data.SDTAccount) {
              setAccountData(
                { AccountId: data.SDTAccount.AccountOnboardingId, Questions: data.SDTAccount.Questions },
                false
              );
              setQuestions(data.SDTAccount.Questions);
            }
          });
        } else {
          services.fetchAccountSectorInfo(body, (data) => {
            if (data && data.SDTAccount) {
              setAccountData({ AccountId: accountId, Questions: data.SDTAccount.Questions }, false);
            }
          });
        }
      } else {
        setQuestions(accQuestions);
      }
    }
  }, [setAccountData, accQuestions, accountId, services]);

  useEffect(() => {
    if (mode === AccountMode.New) {
      const body = {
        AccountGetInfo: {
          GetAccountDataOnboardingId: accountId,
          GetAccountDataId: accountId,
          GetAccountDataType: getAccountType.Questions,
        },
      };

      services.fetchNewAccountInfo(body, (data) => {
        if (data && data.SDTAccount) {
          setAccountData(
            { AccountId: data.SDTAccount.AccountOnboardingId, Questions: data.SDTAccount.Questions },
            false
          );
          setQuestions(data.SDTAccount.Questions);
        }
      });
    }
  }, []);

  const handleSave = () => {
    const questionschanged = valueref.current;
    const body = {
      account: {
        AccountId: accountId,
        Questions: questionschanged,
      },
      accountChangeType: getAccountType.Questions,
    };
    if (mode === AccountMode.New) {
      setLoadingSave(true);
      const newQuestions = questionschanged.map((q) => {
        if (Number(q.NewAnswerId) > 0) {
          const newAnswers = [];
          let newA = {};
          q.Answer.forEach((a) => {
            newA = {};
            if (a.AnswerId === q.NewAnswerId) {
              newA = {
                ...a,
                AnswerIsResponse: true,
              };
            } else {
              newA = {
                ...a,
                AnswerIsResponse: false,
              };
            }
            newAnswers.push(newA);
          });
          return {
            ...q,
            NewAnswerId: 0,
            Answer: newAnswers,
          };
        }
        return { ...q };
      });
      const bodyN = {
        account: {
          AccountOnboardingId: accountId,
          Questions: newQuestions,
        },
        accountChangeType: getAccountType.Questions,
      };
      services.fetchNewAccount(bodyN, (res) => {
        if (res) {
          setAccountData(
            {
              AccountId: account.AccountOnboardingId,
              Questions: newQuestions,
            },
            true
          );
          setLoadingSave(false);
          showToast("Changes saved successfully");
        } else {
          setLoadingSave(false);
        }
      });
    } else {
      services.fetchAccountUpdate(body, (result) => {
        if (result && result.result.Code === 200) {
          const newQuestions = questionschanged.map((q) => {
            if (q.NewAnswerId > 0) {
              const newAnswers = [];
              let newA = {};
              q.Answer.forEach((a) => {
                newA = {};
                if (a.AnswerId === q.NewAnswerId) {
                  newA = {
                    ...a,
                    AnswerIsResponse: true,
                  };
                } else {
                  newA = {
                    ...a,
                    AnswerIsResponse: true,
                  };
                }
                newAnswers.push(newA);
              });
              return {
                ...q,
                NewAnswerId: 0,
                Answer: newAnswers,
              };
            }
            return { ...q };
          });

          setAccountData(
            {
              AccountId: accountId,
              Questions: newQuestions,
            },
            true
          );
          setLoadingSave(false);
        } else {
          setLoadingSave(false);
        }
      });
    }
  };

  const handleChangeAnswer = (questionIndex, answerIndex) => {
    if (!loadingSave) {
      const newQuestions = [...questions];
      if (newQuestions[questionIndex].Answer[answerIndex].AnswerIsResponse) {
        newQuestions[questionIndex].NewAnswerId = 0;
      } else {
        newQuestions[questionIndex].NewAnswerId = questions[questionIndex].Answer[answerIndex].AnswerId;
      }
      setQuestions(newQuestions);
    }
  };

  useEffect(() => {
    return () => {
      if (mode === AccountMode.New) {
        handleSave();
      }
    };
  }, []);

  useEffect(() => {
    valueref.current = questions;
  }, [questions]);

  useEffect(() => {
    accountref.current = account;
  }, [account]);

  let save = false;
  if (!questions) {
    return <CircularProgress sm />;
  }
  return (
    <div>
      {questions.map((q, qIndex) => {
        if (q.NewAnswerId > 0) {
          save = true;
        }
        return (
          <Form key={q.QuestionId}>
            <FormGroup tag="fieldset">
              <legend>{q.QuestionDescription}</legend>
              {q.Answer.map((a, aIndex) => (
                <FormGroup check key={a.AnswerId}>
                  <Label style={{ color: a.AnswerId === q.NewAnswerId ? "#36a9e1" : "black" }} check>
                    <Input
                      type="radio"
                      name="radio1"
                      defaultChecked={a.AnswerIsResponse}
                      value={a.AnswerIsResponse ? q.NewAnswerId === 0 : q.NewAnswerId === a.AnswerId}
                      onChange={() => handleChangeAnswer(qIndex, aIndex)}
                      disabled={isReadOnly}
                    />
                    {` ${a.AnswerDescription}`}
                  </Label>
                </FormGroup>
              ))}
            </FormGroup>
          </Form>
        );
      })}
      {riskByPersonIsEnabled && questions.length > 0 && !isReadOnly && (
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={loadingSave}
          // disabled={!save}
          onClick={() => handleSave()}
          data-style={EXPAND_RIGHT}
        >
          Save
        </LaddaButton>
      )}
    </div>
  );
};

Questions.propTypes = {
  questions: PropTypes.array.isRequired,
  accountId: PropTypes.any.isRequired,
  setAccountData: PropTypes.func.isRequired,
  services: PropTypes.func.isRequired,
  account: PropTypes.func.isRequired,
  mode: PropTypes.func.isRequired,
};

export default Questions;
